/* globals ClientStats, AjaxSookie */

import $ from "jquery";
import blockadblock from "shared/modules/BlockAdBlock/blockadblock";
import Context from "shared/util/Context";
import { isDesktop } from "shared/util/EnvironmentHelpers";

$(document).ready(() => {
	if (!Context.get("username") || Context.get("adFree") || !isDesktop) {
		return;
	}

	const instance = new blockadblock();
	const blockedPageviews = Context.get("blockedPageviews");
	const age = Context.getUserDemo("age");
	const gender = Context.getUserDemo("gender");
	let ageRange;

	// bail on users in onboarding who haven't yet set their basics
	if (gender === 0 || age < 18 || age > 99) {
		return;
	}

	if (age <= 34) {
		ageRange = "18-34";
	} else if (age <= 49) {
		ageRange = "35-49";
	} else {
		ageRange = "50 and up";
	}

	const demo = `gender:${({ 1: "M", 2: "F" })[gender]} - age:${ageRange}`;

	instance.onDetected(() => {
		ClientStats.update("ads - ad blockers - using:true");
		ClientStats.update(`ads - ad blockers - using:true - ${demo}`);
		if (blockedPageviews < 10) {
			AjaxSookie.update("blocked_pageviews", blockedPageviews + 1, 86400 * 365, "7d53c21b09e7e85ce8cb85187223a3fe6d7f0c5c");
		}
	});

	instance.onNotDetected(() => {
		ClientStats.update("ads - ad blockers - using:false");
		ClientStats.update(`ads - ad blockers - using:false - ${demo}`);

		if (blockedPageviews) {
			AjaxSookie.remove("blocked_pageviews");
		}
	});

	instance.check();
});



// WEBPACK FOOTER //
// ./src/legacy/adblock.js